/* React base class */
import { Component } from "react"

/* Redux store connection */
import { connect } from "react-redux"

/* Router HOC */
import { withRouter, applySeo } from "../../helpers"

/* Shared UI components */
import { Account, Card } from "../../components"

/* Icon component */
import Icon from "../../components/Icon"

/* i18n */
import { translate } from "../../translates"

/* Page Favourites */
class Favourites extends Component {

    componentDidMount = () => {

        /* SEO */
        applySeo({ title: `Избранное — Bookify`, description: `Сохранённые вами заведения в Bookify.`, path: `/favourites`, robots: `noindex, follow` })

        /* Scroll */
        window.scroll(0, 0)
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const favourites = Array.isArray(this.props.favourites) ? this.props.favourites : []

        /* Empty */
        if (favourites.length === 0) {
            return (
                <div className="empty">
                    <div className="empty__art"><Icon name="heart" size={56} /></div>
                    <h3>{translate("Здесь пока ничего нет")}</h3>
                    <p>{translate("Добавьте организации в избранное, чтобы не потерять.")}</p>
                    <button className="btn" onClick={() => this.props.navigate("/")}>{translate("На главную")}</button>
                </div>
            )
        }

        /* Grid */
        return (
            <div className="grid grid--3">
                {favourites.map((organization) => (
                    <Card key={`${organization.id}`} s={organization} />
                ))}
            </div>
        )
    }

    render = () => {
        return (
            <Account active="favorites">
                <div className="content">
                    <h2 className="content__title">{translate("Избранное")}</h2>
                    <p className="content__subtitle">{translate("Организации, которые вы сохранили")}</p>

                    {this._content()}
                </div>
            </Account>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        favourites: state.favourites,
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(withRouter(Favourites))
